const production = true;

const appData = {
  appVersion: "1.9.6",
  appIntVersion: 196,
  appProduction: production,
  appCode: "otodis",
};

export const appProduction = appData?.appProduction;
export const appCode = appData?.appCode;
export const appVersion = appData?.appVersion;
export const appIntVersion = appData?.appIntVersion;
